import React from 'react';

export const SingleColumnLayout = ({ slots, spacingMultiplier = 1.0 }) => {
  const { header, main, footer } = slots;
  
  return (
    <div 
      className="resume-layout-single" 
      style={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100%',
        boxSizing: 'border-box',
        gap: `calc(var(--spacing-element-gap, 16px) * ${spacingMultiplier})`
      }}
    >
      {header && (
        <header className="resume-header-slot" style={{ width: '100%' }}>
          {header}
        </header>
      )}

      <main className="resume-main-slot" style={{ width: '100%', flex: 1 }}>
        {main}
      </main>

      {footer && (
        <footer className="resume-footer-slot" style={{ width: '100%' }}>
          {footer}
        </footer>
      )}
    </div>
  );
};
